<template>
  <div class="cart-page">
    <div class="main-container header-section" style="padding: 0;">
      <div class="header-top">
        <h1 class="brand-title">SHOPPING CART</h1>
      </div>
      <div class="filter-bar"></div>
    </div>
    <div class="main-container content-section main_null" v-show="dataList.length == 0">PLEASE CONTINUE BROWSING</div>
    <div class="main-container" v-show="dataList.length > 0">
      <el-form ref="cartForm" :model="{ list: dataList }" :rules="cartFormRules">
        <div class="cart-list">
          <div v-for="(item, index) in dataList" :key="index" class="cart-item">
            <el-row :gutter="30" class="item-row">

              <!-- 1. 产品图片 -->
              <el-col :xs="10" :sm="6" :md="5" :lg="5">
                <div class="image-box">
                  <img :src="item.image ? imageUtils(websiteImg, item.image) : blhcImageCopy('car_bg_def.png')"
                    alt="Product" />
                </div>
              </el-col>

              <!-- 2. 表单信息 (中间) -->
              <el-col :xs="14" :sm="10" :md="14" :lg="12">
                <div class="info-box">
                  <h3 class="p-name" style="margin-bottom: 25px;">{{ item.productName || '/' }}</h3>
                  <!-- <div class="p-model">{{ item.productNo || '/' }}</div> -->
                  <!-- 宽/高 输入行 -->
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="12">
                      <div class="floating-label-input">
                        <label :style="{ color: item.cpDelFlag == 1 ? '#C9CDD4' : '#4a4a4a' }">Width (cm)</label>
                        <el-form-item :prop="'list.' + index + '.width'" :rules="widthRules">
                          <el-input v-model="item.width" placeholder="Width" @blur="EditProduct(item, index, 'width')"
                            :disabled="item.cpDelFlag == 1"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                      <div class="floating-label-input">
                        <label :style="{ color: item.cpDelFlag == 1 ? '#C9CDD4' : '#4a4a4a' }">Height (cm)</label>
                        <el-form-item :prop="'list.' + index + '.height'" :rules="heightRules">
                          <el-input v-model="item.height" placeholder="Height"
                            @blur="EditProduct(item, index, 'height')" :disabled="item.cpDelFlag == 1"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <!-- 面料/数量 输入行 -->
                  <el-row :gutter="20" class="fabric-row">
                    <el-col :xs="24" :sm="12">
                      <div class="floating-label-input select-wrapper">
                        <label :style="{ color: item.cpDelFlag == 1 ? '#C9CDD4' : '#4a4a4a' }">Fabric</label>
                        <el-select v-model="item.pcId" placeholder="Select Fabric" popper-class="custom-popper"
                          style="width: 100%;" class="custom-select" @change="EditProduct(item, index, true)"
                          :no-data-text="'No Data Found'" :disabled="item.cpDelFlag == 1" >
                          <template slot="prefix">
                            <img :src="imageUtils(websiteImg, item.cover)" class="input-prefix-icon"
                              v-show="item.cover" />
                          </template>
                          <el-option v-for="opt in IdColorList(item.cpId)" :key="opt.pcId" :label="opt.colorContent"
                            :value="opt.pcId">
                            <div class="option-flex">
                              <img :src="imageUtils(websiteImg, opt.cover)" class="option-img" />
                              <span>{{ opt.colorContent }}</span>
                            </div>
                          </el-option>
                        </el-select>
                        <div style="color: #F56C6C; font-size: 12px; margin-top: 3px;" v-show="!item.pcId && item.cpDelFlag == 0">Please select
                          fabric</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                      <div class="floating-label-input">
                        <label :style="{ color: item.cpDelFlag == 1 ? '#C9CDD4' : '#4a4a4a' }">Qty</label>
                        <el-form-item :prop="'list.' + index + '.quantity'" :rules="numberRules">
                          <el-input v-model="item.quantity" placeholder="Qty" style="width: 60%;"
                            @blur="EditProduct(item, index, 'quantity')" :disabled="item.cpDelFlag == 1"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="notice-text" v-show="item.cpDelFlag == 1">
                    This product does not exist. Please select again.
                  </div>
                </div>
              </el-col>

              <!-- 3. 操作栏 -->
              <el-col :xs="24" :sm="6" :md="5" :lg="7">
                <div class="price-remove-group">
                  <div class="price-text" :style="{ color: item.cpDelFlag == 1 ? '#C9CDD4' : '#4a4a4a' }">$ {{ item.price
                    }}</div>
                  <div class="remove-btn" @click="removeItem(item)" style="width: 100%;">REMOVE</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
      <!--结算 -->
      <div class="footer-section">
        <el-row :gutter="60">
          <!-- 地址栏 -->
          <el-col :xs="24" :md="12">
            <h4 class="footer-title">ADDRESS</h4>
            <div class="address-box" v-if="addRessData">
              <div>
                {{ addRessData.firstName }} {{ addRessData.lastName }}
              </div>
              <div> {{  addRessData.address ? addRessData.address + ',' : '' }} {{  addRessData.apt ?  addRessData.apt + ',' : ''  }}{{  addRessData.city ?  addRessData.city + ',' : ''  }} {{  addRessData.state ?  addRessData.state + ',' : '' }} {{ addRessData.postCode ? addRessData.postCode + ',' : '' }} {{  addRessData.country }} 
                </div>
              <div>{{ addRessData.phone }}</div>
            </div>
            <div class="footer-title-box">
              <div class="add-new-link" @click="openAddressDrawer" style="margin-right: 50px;"
                v-show="addressList.length > 0">CHANGE</div>
              <div class="add-new-link" @click="visible = true">ADD NEW</div>
            </div>

          </el-col>

          <!-- 订单汇总 -->
          <el-col :xs="24" :md="12">
            <h4 class="footer-title">ORDER SUMMARY</h4>

            <div class="summary-list">
              <div v-for="(item, idx) in dataList" :key="idx" class="summary-item">
                <span class="s-name">{{ item.productName }}
                  <!-- ({{ item.productNo }}) -->
                </span>
                <!-- <span class="s-qty">Qty {{ item.quantity }}</span> -->
                <span class="s-price">$ {{ (item.price * item.quantity).toFixed(2) }}</span>
              </div>
            </div>

            <div class="divider-line"></div>

            <div class="total-bar">
              <span>TOTAL</span>
              <span>$ {{ totalPrice.toFixed(2) }}</span>
            </div>

            <button class="checkout-btn" @click="checkout">CHECKOUT</button>
          </el-col>
        </el-row>
      </div>

    </div>
    <Address :visible="visible" @closeHandler="handleClose" />
    <!-- 地址抽屉 -->
    <el-drawer :visible.sync="isShowAddressDrawer" direction="rtl" :before-close="handleAddressDrawer"
      :append-to-body="true" :size="screenWidth <= 768 ? '100%' : '500px'" :show-close="false"
      custom-class="address-drawer" :with-header="false">
      <div class="drawer-header">
        <div class="drawer-title">CHANGE ADDRESS</div>
        <button class="close-btn" @click="handleAddressDrawer"><i class="el-icon-close"></i></button>
      </div>

      <div class="drawer-body" @scroll="handleAddressScroll">
        <div class="address-list" v-for="(item, idx) in addressList" :key="idx" @click="changeAddress(item)">
          <div class="address-title">
            <div>
              <div class="checkbox-icon" :class="{ 'checked': selAddress.wdId == item.wdId }">
                <i v-if="selAddress.wdId == item.wdId" class="el-icon-check"></i>
              </div>
              {{ item.firstName }} {{ item.lastName }}
            </div>
            {{ item.phone }}
          </div>

          <div>
            {{ item.address }} {{ item.apt }} {{ item.country }} {{ item.postCode }}
            {{ item.state }} {{ item.city }}
          </div>
        </div>
      </div>
      <div v-if="addressLoading" style="text-align: center; padding: 10px; color: #999;">
        <i class="el-icon-loading"></i> Loading...
      </div>
      <!-- <div v-if="isAddressFinished && addressList.length > 0"
        style="text-align: center; padding: 10px; color: #ccc; font-size: 12px;">
        No more addresses
      </div> -->
      <div class="form-footer">
        <el-button type="primary" class="save-btn" @click="updateAddress()">
          CONFIRM
        </el-button>
        <div class="cancel-link" @click="isShowAddressDrawer = false">CANCEL</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import '@/style/cart.scss';
import Address from '@/components/address.vue'
import { productShoppingCartList, selectProductColorList, deleteProductShoppingCart, updateProductShoppingCart, userAddressPojoList, getDefaultFlagAddress, updateShoppingCartAddress, productShoppingCartToOrder } from '@/api/member'
import { imageUtils, blhcImageCopy } from '@/utils/imageUtil';
import utils from '@/utils/util.js';
export default {
  name: "CartResponsive",
  components: {
    Address
  },
  data() {
    const validateDimension = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        return callback(new Error('Please enter a value'));
      }
      const reg = /^\d+(\.\d+)?$/;
      if (!reg.test(value)) {
        return callback(new Error('Please enter a valid number'));
      }
      const num = parseFloat(value);
      if (num < 1) {
        return callback(new Error('cannot be less than 1'));
      }
      // 校验通过
      callback();
    };

    // 校验宽度不超过最大值
    const validateWidth = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        return callback(new Error('Please enter a value'));
      }
      const reg = /^\d+(\.\d+)?$/;
      if (!reg.test(value)) {
        return callback(new Error('Please enter a valid number'));
      }
      const num = parseFloat(value);
      if (num <= 0) {
        return callback(new Error('cannot be less than 0'));
      }

      // 获取当前表单项索引
      const index = parseInt(rule.field.split('.')[1]);
      const item = this.dataList[index];
      if (item && item.widthMax && num > item.widthMax) {
        return callback(new Error(`Width cannot exceed the maximum value ${item.widthMax}`));
      }

      // 校验通过
      callback();
    };

    // 校验高度不超过最大值
    const validateHeight = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        return callback(new Error('Please enter a value'));
      }
      const reg = /^\d+(\.\d+)?$/;
      if (!reg.test(value)) {
        return callback(new Error('Please enter a valid number'));
      }
      const num = parseFloat(value);
      if (num <= 0) {
        return callback(new Error('cannot be less than 0'));
      }

      // 获取当前表单项索引
      const index = parseInt(rule.field.split('.')[1]);
      const item = this.dataList[index];
      if (item && item.heightMax && num > item.heightMax) {
        return callback(new Error(`Height cannot exceed the maximum value ${item.heightMax}`));
      }

      // 校验通过
      callback();
    };

    return {
      websiteImg: utils.websiteImg,
      screenWidth: document.documentElement.clientWidth || window.innerWidth,
      visible: false,
      dataList: [],
      typeList: [],
      // 地址抽屉
      pageNo: 1,
      isShowAddressDrawer: false,
      addRessData: {},
      selAddress: {},
      addressList: [],
      addressLoading: false, // 是否正在请求中
      isAddressFinished: false, // 是否已加载全部数据
      // 校验规则对象
      numberRules: [
        { required: true, validator: validateDimension, trigger: ['blur', 'keyup.enter'] }
      ],
      widthRules: [
        { required: true, validator: validateWidth, trigger: ['blur', 'keyup.enter'] }
      ],
      heightRules: [
        { required: true, validator: validateHeight, trigger: ['blur', 'keyup.enter'] }
      ],
      // 动态表单验证规则
      cartFormRules: {}

    };
  },
  computed: {
    totalPrice() {
      return this.dataList.reduce((acc, cur) => acc + (cur.price * cur.quantity), 0);
    }
  },
  watch: {
    '$route': {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.cartForm) {
            // 只清除提示，不重置数据
            this.$refs.cartForm.clearValidate();
          }
        });
      },
      immediate: false
    }
  },
  async activated() {
    await this.getColorList()
    this.getList()
    this.getAddress()
    this.getAddressInfo()
    this.generateFormRules();

    this.$nextTick(() => {
      if (this.$refs.cartForm) {
        this.$refs.cartForm.clearValidate();
      }
    });
  },
  methods: {
    imageUtils,
    blhcImageCopy,
    // 提交订单
    // 提交订单
    checkout() {
      // 第一步：先进行全表单校验（校验所有产品的宽高、数量）
      this.$refs.cartForm.validate((valid) => {
        if (!valid) {
          this.$message({
            message: 'Please check the product details and fill in correct values.',
            type: 'error'
          });
          return false;
        }

        // 第二步：校验地址
        if (!this.addRessData.wdId) {
          this.$message({
            message: 'Please select an address',
            type: 'error'
          });
          return;
        }

        // 第三步：校验价格
        if (this.totalPrice == 0) {
          this.$message({
            message: 'Please contact customer service to configure the price',
            type: 'error'
          });
          return;
        }

        // 第四步：执行提交接口
        productShoppingCartToOrder({
          wdId: this.addRessData.wdId,
        }).then(res => {
          if (res.code == 1) {
            this.$message({
              message: 'Success',
              type: 'success'
            });
            this.$eventBus.$emit('updateCartCount'); 
            this.$router.push({
              path: '/member/SuccessfullyOrdered',
              query: { orderId: res.data.dataDetails.orderId }
            });
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        });
      });
    },
    // 获取默认地址
    getAddressInfo() {
      getDefaultFlagAddress().then(res => {
        if (res.code == 1) {
          this.addRessData = res.data.dataDetails || {}
        }
      })
    },
    handleAddressDrawer() {
      this.isShowAddressDrawer = false
    },
    // 选择地址
    changeAddress(item) {
      this.selAddress = item || {}
    },
    updateAddress() {
      this.addRessData = JSON.parse(JSON.stringify(this.selAddress))
      this.isShowAddressDrawer = false
      updateShoppingCartAddress({
        wdId: this.addRessData.wdId,
      }).then(res => {
        if (res.code == 1) {
          this.getAddressInfo()

        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    getAddress() {
      // 如果正在加载或数据已全部加载完毕，则不请求
      if (this.addressLoading || (this.isAddressFinished && this.pageNo > 1)) return;
      this.addressLoading = true;

      userAddressPojoList({ pageNo: this.pageNo, pageSize: 20 }).then(res => {
        if (res.code == 1) {
          const newList = res.data.dataList || [];
          const total = res.data.count || 0;
          if (this.pageNo == 1) {
            this.addressList = newList;
            this.isAddressFinished = false;
          } else {
            this.addressList = [...this.addressList, ...newList];
          }
          if (this.addressList.length >= total) {
            this.isAddressFinished = true;
          }
        }
      }).catch(err => {
        console.error(err);
        if (this.pageNo > 1) this.pageNo--;
      }).finally(() => {
        this.addressLoading = false;
      });
      console.log('请求结束', this.addressLoading, this.isAddressFinished);
    },

    // 监听滚动事件
    handleAddressScroll(e) {
      const target = e.target;
      // 滚动条距离顶部高度 + 可视区域高度
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;

      console.log(scrollTop + clientHeight >= scrollHeight - 50);
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        console.log('滚动到底部', this.addressLoading, this.isAddressFinished);
        if (!this.addressLoading && !this.isAddressFinished) {
          this.pageNo++;
          this.getAddress();
        }
      }
    },
    async openAddressDrawer() {
      this.isShowAddressDrawer = true;
      this.pageNo = 1; // 重置页码
      this.isAddressFinished = false; // 重置结束状态
      this.$nextTick(() => {
        const body = document.querySelector('.drawer-body');
        if (body) body.scrollTop = 0;
      });
      await this.getAddress();
      this.selAddress = this.addRessData ? JSON.parse(JSON.stringify(this.addRessData)) : {}
    },
    handleClose(data) {
      this.visible = false
      if (data && data.wdId) {
        this.selAddress = data
        this.updateAddress()
        this.getAddress()
      }
    },
    getList(type = 1) {
      if (type == 1) {
        var loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.8)'
        });
      }
      productShoppingCartList().then(res => {
        if (res.code == 1) {
          this.dataList = res.data.dataList || []
          this.generateFormRules();
        }
        this.$nextTick(() => {
          if (this.$refs.cartForm) {
            this.$refs.cartForm.clearValidate();
          }
        });
      }).finally(() => {
        if (type == 1) {
          setTimeout(() => {
            loading.close();
          }, 200);
        }
      });
    },
    async getColorList() {
      await selectProductColorList().then(res => {
        if (res.code == 1) {
          this.typeList = res.data.dataList || []
        }
      })
    },
    //根据产品ID获取色卡
    IdColorList(id) {
      let colorList = this.typeList.filter(item => item.cpId == id)
      return colorList[0].productColorList
    },
    // 编辑产品
    EditProduct(data, index, propName) {
      // 1. 如果是下拉框(Fabric)变更，通常不需要单独触发校验逻辑（或直接更新）
      if (propName === true) {
        updateProductShoppingCart(data).then(res => {
          if (res.code == 1) this.getList(0);
        });
        return;
      }

      // 2. 构造 ElementUI 需要的校验路径，例如 "list.0.width"
      const fieldProp = `list.${index}.${propName}`;

      // 3. 仅校验当前失去焦点的这一个字段
      this.$refs.cartForm.validateField(fieldProp, (errorMessage) => {
        // errorMessage 为空表示校验通过
        if (!errorMessage) {
          updateProductShoppingCart(data).then(res => {
            if (res.code == 1) {
              this.getList(0);
              this.$eventBus.$emit('updateCartCount'); 
            }
          });
        }
      });
    },
    // 生成表单验证规则
    generateFormRules() {
      const rules = {};
      this.dataList.forEach((item, index) => {
        rules[`list.${index}.width`] = this.widthRules;
        rules[`list.${index}.height`] = this.heightRules;
        rules[`list.${index}.quantity`] = this.numberRules;
      });
      this.cartFormRules = rules;
    },
    removeItem(data) {
      this.$confirm('Confirm deletion?', 'Hint', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning',
        confirmButtonClass: 'ExitConfirmButton',
        cancelButtonClass: 'ExitCancelButton',
      }).then(() => {
        deleteProductShoppingCart({
          cartId: data.cartId
        }).then(res => {
          if (res.code == 1) {
            this.getList()
            this.$eventBus.$emit('updateCartCount'); 
          }
        })
      })
    }
  }
};
</script>


<style lang="scss">
.custom-popper {
  z-index: 1000 !important;
}
.custom-popper .option-flex {
  display: flex;
  align-items: center;
}

.custom-popper .option-img {
  width: 24px;
  height: 24px;
  margin-right: 10px;
  object-fit: cover;
}

.custom-popper .el-select-dropdown__item {
  font-family: "NotoSerif", serif;
}




.floating-label-input .el-input__inner {
  background-color: transparent;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  height: 50px;
  line-height: 50px;
  font-family: "NotoSerif", serif;
  font-size: 16px;
  color: #000;
  padding-left: 15px;
}

::v-deep .floating-label-input .el-input__inner:focus {
  border-color: #999;
}

::v-deep .floating-label-input .el-input__inner::placeholder {
  color: #ccc;
}

.select-wrapper ::v-deep .el-input__inner {
  padding-left: 40px;
}
</style>